import { useState } from "react"

import { useRunSubmission } from "./use-run-submission"

/** One history cursor and query serve both the workflow and its attention label. */
export function useRunSubmissionState(slug: string) {
  const [historyPage, setHistoryPage] = useState({ slug, offset: 0 })
  const historyOffset = historyPage.slug === slug ? historyPage.offset : 0
  const submission = useRunSubmission(slug, historyOffset)
  return {
    progress: submission.data,
    error: submission.error,
    onHistoryPage: (offset: number) => setHistoryPage({ slug, offset }),
  }
}
